import { useAtomValue } from 'jotai';
import { Navigate } from 'react-router-dom';
import { Stack, TableRow, TableCell, Typography } from '@mui/material';

import { usersAtom } from '@/interfaces/admin';
import AdminTable from '@/components/admin/AdminTable';
import AdminDataTable from '@/components/admin/AdminDataTable';
import type { TableData } from '@/@types/admin';

const tableData: TableData = {
  showCheckbox: false,
  keys: ['name', 'role', 'registerData'],
  header: ['사이트 이름', '권한', '등록일'],
  rows: [
    { name: '엠투클라우드 사이트 #1', role: '관리자', registerDate: '2025-01-01' },
    { name: '엠투클라우드 사이트 #2', role: '멤버', registerDate: '2025-01-04' },
  ],
};

export default function UsersViewDetail() {
  const id = window.history.state?.usr?.id;
  const { isPending, data } = useAtomValue(usersAtom);

  if (!id) return <Navigate to="/admin/users/view" />;
  if (isPending) return <></>;

  const user = data[Number(id)];

  return (
    <Stack gap={3}>
      <AdminTable>
        <TableRow>
          <TableCell className="label">회원 상태</TableCell>
          <TableCell colSpan={3}>{user.status}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="label">이름</TableCell>
          <TableCell>{user.name}</TableCell>
          <TableCell className="label">아이디(이메일)</TableCell>
          <TableCell>{user.email}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="label">전화번호</TableCell>
          <TableCell>{user.tel}</TableCell>
          <TableCell className="label">생일</TableCell>
          <TableCell>{user.birthday}</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="label">주소</TableCell>
          <TableCell>서울특별시 송파구 송파대로 167</TableCell>
          <TableCell className="label">우편번호</TableCell>
          <TableCell>05855</TableCell>
        </TableRow>
        <TableRow>
          <TableCell className="label">가입일</TableCell>
          <TableCell>{user.registerDate}</TableCell>
          <TableCell className="label">수정일</TableCell>
          <TableCell>{user.editDate}</TableCell>
        </TableRow>
      </AdminTable>

      <Typography variant="h5" fontWeight="bold">
        사이트 목록
      </Typography>
      <AdminDataTable data={tableData} />
    </Stack>
  );
}
